import { render, staticRenderFns } from "./index.mpx?vue&type=template&id=2fcae0ed&scoped=true&component=true&componentId=indexfc854284"
import script from "./index.mpx?vue&type=script&lang=js&component=true&componentId=indexfc854284"
export * from "./index.mpx?vue&type=script&lang=js&component=true&componentId=indexfc854284"
import style0 from "./index.mpx?vue&type=style&index=0&id=2fcae0ed&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22mfc854284%22%7D&component=true&componentId=indexfc854284"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcae0ed",
  null
  
)

export default component.exports